import $ from 'jquery';

export const customCursor = {
    mouseCursor: document.querySelector('.cursor'),
    addClass({target}) {
        let attribute = 
            target.tagName == 'A' || target.closest('a')? 
                'LINK'
                : 
            target.getAttribute('data-cursor')?
                target.getAttribute('data-cursor') 
                :
            target.closest('[data-cursor]')?
                target.closest('[data-cursor]').getAttribute('data-cursor')
                :
            target.classList.value !== ''?
                target.classList
                :
            `${target.parentNode.classList} ${target.tagName}`;

        if(attribute == "LINK" && target.closest('a').className == "partner__link")
            attribute = "partners";
        if(attribute == "LINK" && target.closest('a').href == "javascript:void(0)")
        {
            if(target.closest('a').classList.contains("title"))
                attribute = "NOLINK"; 
            else attribute = "";
        }
        
        this.mouseCursor.setAttribute('data-style', attribute)
       
    },

    cursor(event) {
        const {clientX, clientY} = event;
        this.mouseCursor.style.cssText = `
            left: ${clientX}px;
            top: ${clientY}px;
        `
        this.addClass(event);
    },

    event() {
        document.addEventListener('mousemove', this.cursor.bind(this));
    },

    init() {
        this.event()
    }
}


// WEBPACK FOOTER //
// app/scripts/components/cursor.js